import routeParams from 'helpers/routeParams'

const GET_TASKS_AWARD_UNITS = 'dofe-bo/tasksAwardUnits/GET_TASKS_AWARD_UNITS'
const GET_TASKS_AWARD_UNITS_SUCCESS =
  'dofe-bo/tasksAwardUnits/GET_TASKS_AWARD_UNITS_SUCCESS'
const GET_TASKS_AWARD_UNITS_FAIL =
  'dofe-bo/tasksAwardUnits/GET_TASKS_AWARD_UNITS_FAIL'

const EXPORT_TASKS_AWARD_UNITS =
  'dofe-bo/tasksAwardUnits/EXPORT_TASKS_AWARD_UNITS'
const EXPORT_TASKS_AWARD_UNITS_SUCCESS =
  'dofe-bo/tasksAwardUnits/EXPORT_TASKS_AWARD_UNITS_SUCCESS'
const EXPORT_TASKS_AWARD_UNITS_FAIL =
  'dofe-bo/tasksAwardUnits/EXPORT_TASKS_AWARD_UNITS_FAIL'
const SET_FILTER = 'dofe-bo/tasksAwardUnits/SET_FILTER'
const SET_BASE_FILTER = 'dofe-bo/tasksAwardUnits/SET_BASE_FILTER'
const SET_PARAMS = 'dofe-bo/tasksAwardUnits/SET_PARAMS'
const SET_DISABLED_CACHE = 'dofe-bo/tasksAwardUnits/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/tasksAwardUnits/REMOVE_DETAIL_DATA'

const initialState = {
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  filter: '',
  count: null,
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_AWARD_UNITS:
      return {
        ...state,
        loading: true
      }
    case GET_TASKS_AWARD_UNITS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: action.headers['x-total-count'],
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_TASKS_AWARD_UNITS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy
      })
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    default:
      return state
  }
}

export function getTasksRegistrationAwardUnits(params, baseFilter) {
  return {
    types: [
      GET_TASKS_AWARD_UNITS,
      GET_TASKS_AWARD_UNITS_SUCCESS,
      GET_TASKS_AWARD_UNITS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-unit-registration-approval?with=ORGANIZATION${routeParams(params, baseFilter)}`
      )
  }
}

export function exportTasksRegistrationAwardUnits(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_TASKS_AWARD_UNITS,
      EXPORT_TASKS_AWARD_UNITS_SUCCESS,
      EXPORT_TASKS_AWARD_UNITS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-unit-registration-approval?with=ORGANIZATION${routeParams({ filter: params.filter }, baseFilter)}`
      )
  }
}

export function setAwardUnitsFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setAwardUnitsBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setTasksAwardUnitsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function removeDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}
